"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBsi = exports.buildImageUrl = void 0;
var get_resized_image_url_1 = require("../../../../../common/utils/get-resized-image-url");
var cookie_1 = require("../../../../../common/utils/cookie");
var SHARE_IMAGE_WIDTH = 480;
var SHARE_IMAGE_HEIGHT = 360;
var buildImageUrl = function (url) {
    return (0, get_resized_image_url_1.getResizedImageUrl)({
        url: url,
        width: SHARE_IMAGE_WIDTH,
        height: SHARE_IMAGE_HEIGHT,
    });
};
exports.buildImageUrl = buildImageUrl;
var getBsi = function () {
    try {
        if (window.commonConfig) {
            return window.commonConfig.bsi;
        }
        if (window.Wix) {
            return Wix.Utils.commonConfig.get('bsi');
        }
        return (0, cookie_1.getCookie)('bSession');
    }
    catch (_a) {
        return undefined;
    }
};
exports.getBsi = getBsi;
//# sourceMappingURL=index.js.map